import { userConstants } from "../constants/login.constants";

  function ebinderPrimeFileList(state = {}, action) {
     switch (action.type) {
         case userConstants.GETEBINDERPRIMEFILELIST_REQUEST:
             return {
                 loading: true
             };
         case userConstants.GETEBINDERPRIMEFILELIST_SUCCESS:
             return {
                 items: action.ebinderPrimeFileList
             };
         case userConstants.GETEBINDERPRIMEFILELIST_FAILURE:
             return {
                 error: action.error
             };
         default:
             return state
     }
 }
 export default ebinderPrimeFileList;
